export type RoleIssueKind = 'missingMembership' | 'unknownRole';
export type RoleIssueVariant = 'redirect' | 'guard';

export interface RoleIssueContent {
  icon: string;
  title: string;
  text: string;
}

const ROLE_ISSUE_CONTENT: Record<RoleIssueKind, Record<RoleIssueVariant, RoleIssueContent>> = {
  missingMembership: {
    redirect: {
      icon: '🏢',
      title: 'Нет активной компании',
      text: 'У пользователя нет активной membership-записи, поэтому рабочая область не может быть открыта.',
    },
    guard: {
      icon: '🏢',
      title: 'Компания не назначена',
      text: 'Для этого аккаунта не найдена активная membership-запись. Обратитесь к администратору платформы.',
    },
  },
  unknownRole: {
    redirect: {
      icon: '🛂',
      title: 'Неизвестная роль',
      text: 'Текущая company_role не поддерживается приложением. Обновите данные пользователя в Supabase.',
    },
    guard: {
      icon: '🛂',
      title: 'Роль компании не определена',
      text: 'Не удалось определить активную company_role для текущей компании. Проверьте данные пользователя в Supabase.',
    },
  },
};

export function getRoleIssueContent(kind: RoleIssueKind, variant: RoleIssueVariant): RoleIssueContent {
  return ROLE_ISSUE_CONTENT[kind][variant];
}
